import React from 'react'

const ArrowLeft = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m10.688 11.997 5.095 5.985a.95.95 0 0 1 .217.62.952.952 0 0 1-.217.618l-.447.524a.688.688 0 0 1-.527.256c-.2 0-.386-.09-.526-.256l-6.066-7.126A.951.951 0 0 1 8 11.997c0-.236.076-.456.217-.621l6.06-7.12A.688.688 0 0 1 14.804 4c.2 0 .386.09.527.256l.446.524c.29.341.29.897 0 1.238l-5.089 5.979z" fill={props.fill || "#0D1536"} fill-opacity=".65"/>
</svg>
)

export default ArrowLeft;
